/** @format */

const STATUS_STYLES = {
  0: { label: 'در انتظار بررسی', className: 'badge bg-warning text-dark' },
  1: { label: 'تأیید شده', className: 'badge bg-success' },
  2: { label: 'رد شده', className: 'badge bg-danger' },
};

const ClubStatusBadge = ({ status, label }) => {
  const config = STATUS_STYLES[Number(status)] ?? {
    label: label || 'نامشخص',
    className: 'badge bg-secondary',
  };

  return (
    <span className={config.className}>{label || config.label}</span>
  );
};

export default ClubStatusBadge;
